function calculateHeader() {
  const navHeight     = $('#shopify-section-menu-bar').outerHeight();
  const barHeigh      = $('#shopify-section-announcement-bar .banner').outerHeight();
  const headerHeight  = navHeight + barHeigh + 'px'
  
  return headerHeight;
}

function headerTop() {
  const $bar      = $('#shopify-section-announcement-bar .banner');
  const $nav     = $('#shopify-section-menu-bar');
  const $mobileNavDrawer = $('#nav-drawer__mobile');

  let barHeight = 0;
  let navHeight = 0;

  if ($bar.length) {
    barHeight = $bar.outerHeight();
  }

  if ($nav.length) {
    navHeight = $nav.outerHeight();
  }

  $nav.css({
    'top': barHeight
  });

  $mobileNavDrawer.css({
    'top': barHeight + navHeight
  });
}

function sectionHeaderOffset($section) {  
  if ($section.length) {
    $section.css({
      'padding-top': calculateHeader()
    });
  };
}

sectionHeaderOffset($('.hero-womens'));

$(window).on('resize load', function() {
  setTimeout(function() {
    headerTop();
    sectionHeaderOffset($('.hero-womens'));
  }, 100);
});
